import { useQuery } from '@tanstack/react-query';
import { favoriteMarketService } from 'shared/src/api';
import { queryKey } from '../../../constant/queryKey';

export const useFavoriteMarketsFilterOptions = () => {
  return useQuery({
    queryKey: queryKey.favoriteMarketsFilterOptions(),
    queryFn: () => favoriteMarketService.getFilterOptions(),
  });
};
